(() => {
  const SHOW_AFTER_PX = 400;

  const wrapper = document.querySelector("[data-back-to-top]");
  if (!wrapper) return;

  const button = wrapper.querySelector("button");
  if (!button) return;

  const prefersReducedMotion =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const setVisible = (isVisible) => {
    const nextValue = isVisible ? "true" : "false";
    if (wrapper.dataset.visible === nextValue) return;

    wrapper.dataset.visible = nextValue;
    button.tabIndex = isVisible ? 0 : -1;

    if (!isVisible && typeof button.blur === "function") {
      button.blur();
    }
  };

  let ticking = false;

  const updateVisibility = () => {
    ticking = false;
    const scrollY = window.scrollY ?? window.pageYOffset ?? 0;
    setVisible(scrollY > SHOW_AFTER_PX);
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateVisibility);
  };

  button.addEventListener("click", (event) => {
    event.preventDefault();

    if (prefersReducedMotion) {
      window.scrollTo(0, 0);
      return;
    }

    try {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } catch {
      window.scrollTo(0, 0);
    }
  });

  window.addEventListener("scroll", onScroll, { passive: true });
  updateVisibility();
})();

